import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native"

import LoginEnterPhoneCodeScreen from '../LoginEnterPhoneCodeScreen';
import * as NavigationService from "../../../../../redux/NavigationService";
import store from "../../../../../redux/store";
import i18n from "../../../../../I18n/i18n";
import {typeExport} from "../../../../../redux/store/type";
import {serviceActionSetState} from "../../../splash/action/ActionSplashGetAllData";
import HMAlert from "../../../../../customviews/HMAlert";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    results: state.reducerLoginEnterPhoneCodeScreen.results,
    NoInternetDialog: state.reducerLoginEnterPhoneCodeScreen.NoInternetDialog,
    isLoading: state.reducerLoginEnterPhoneCodeScreen.isLoading,

    DataSplashScreen: state.reducerSplashGetAllData,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData, register) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData, register)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData, register) => {
    let checkTypeLogin = getState.route.params && getState.route.params.type == "forgot_my_password";
    dispatch(serviceActionPending());

    const formData = new FormData();
    formData.append('_operation', params._operation);
    formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('forgotmode', params.forgotmode);
    if (params.HashCode)
        formData.append('HashCode', params.HashCode + "");
    formData.append('mobile', params.mobile);
    formData.append('platform', Platform.OS);
    formData.append('userAgentData', Platform.OS === "web" ? navigator.userAgentData?.mobile : false);
    Tools.addAllFormData(formData,true,"City");

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

    /*  axios(
          {
              //  url: baseUrl + url + params,
              url: url ,
              method: typeConnection,
          //    params: params,
              data:params,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },

          }
      )*/
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    //  axios.post(url, formData, config)
        .then(response => {

            switch (type) {

                case typeExport.TypegetDataLoginEnterPhoneCodeScreen:

                    if (response.data.success) {


                        dispatch(serviceActionSuccess(response.data))
                        // NavigationService.navigateParams('SplashScreen',);

                        NavigationService.navigateParams("EnterCodeScreen", {
                            type: register || global.registerLogin ? "Login_with_activation_code" : (getState.route.params && getState.route.params.type ? getState.route.params.type : ""),

                            mobile: stateData.mobile,
                            result_extra: response.data,
                        });
                    } else {
                        dispatch(serviceActionRefresh())
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.error.message,
                            [
                                {
                                    text: checkTypeLogin ? 'ثبت نام' : i18n.t('constant.ok'), onPress: () => {

                                        if (checkTypeLogin) {
                                            let paramss = {
                                                "_operation": typeExport._Registration,
                                                "lang": i18n.locale,
                                                "mode": typeExport._sendCodeMode,
                                                "mobile": params.mobile,
                                                "forgotmode": "0",

                                            };
                                            global.registerLogin = true;
                                            getDataDisatch(dispatch, getState, url, paramss, type, typeConnection, stateData, true)
                                        } else {

                                        }
                                    }
                                },
                                checkTypeLogin ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : {},


                            ],
                            {cancelable: true}
                        )
                        //alert(response.data.error.message)
                    }

                    break;


                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData, register) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection,stateData);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, register);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )


        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, register);
        } else {
            dispatch(serviceActionError("No Internet Connection"));

        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.LoginEnterPhoneCodeScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.LoginEnterPhoneCodeScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.LoginEnterPhoneCodeScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.LoginEnterPhoneCodeScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginEnterPhoneCodeScreen);
